import { Pipe, PipeTransform } from '@angular/core';

/**
 * 桁数でカンマ区切りされている数字からカンマを削除するパイプクラス
 */
@Pipe({name: 'deleteComma'})
export class DeleteCommaPipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      return value.replace(/,/g, '');
    } else {
      return '';
    }
  }
}
